import OBTRichEditor from './OBTRichEditor';
export default OBTRichEditor;
